import React, { useState,useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import {DragOnDrop} from './styles'
import errorIcon from "../../Toast/Image/error.svg";
import Toast from "../../Toast/Toast";

interface ImageFile extends File {
  preview: string;
}

interface ImageUploadProps {
  onImageChange: (image: ImageFile | null) => void;
  maxFileSize: any;
  onHandleSend: any;
  onExcludeImage:any;
}


  const ImageUpload: React.FC<ImageUploadProps> = ({ onImageChange, maxFileSize, onHandleSend, onExcludeImage}) => {
  
  const [list, setList] = useState<any>([]);

  const showToast = useCallback(
    (type: any) => {
      let toastProperties: {
        id: number;
        title: string;
        description: string;
        backgroundColor: string;
        icon: any;
      } | null = null;

      const id = Math.floor(Math.random() * 101 + 1);
      switch (type) {
        case "LimiteTamanhoArquivo":
            toastProperties = {
              id,
              title: "",
              description: "Arquivo excede o tamanho máximo",
              backgroundColor: "#d72828",
              icon: errorIcon,
             };
            break;

        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [list]
  );
  
  const [image, setImage] = useState<ImageFile | null>(null);
  const [fileName, setFileName] = useState<string | null>(null);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { 'image/jpeg': [], 'image/png': [], 'image/jpg': [], 'application/pdf': []},
    maxSize: maxFileSize,
    onDrop: (acceptedFiles: File[], rejectedFiles: any[]) => {
      if (rejectedFiles.length > 0) {
        // File(s) were rejected due to exceeding maxSize
        showToast('LimiteTamanhoArquivo');
        return;
      }
      if (acceptedFiles.length > 0) {
        setFileName(acceptedFiles[0].name);
        const newImage = Object.assign(acceptedFiles[0], {
          preview: URL.createObjectURL(acceptedFiles[0]),
        }) as ImageFile;
        setImage(newImage);
        onImageChange(newImage);
      }
    },
  });

  const removeImage = (event: React.MouseEvent<HTMLParagraphElement>) => {
    event.stopPropagation(); // Evita a propagação do evento
    setImage(null);
    onImageChange(null);
    onExcludeImage(null);
  };

  return (
    <>
    <Toast toastList={list} autoDelete={true} />
    <DragOnDrop {...getRootProps()} className={`${isDragActive ? 'active' : ''}`}>
      <div>
        {image ? (
          <div className="image-preview">
            <div className="image-item">
              <p className="" >Arquivo: {fileName}</p>
              <p className="remove-button underline" onClick={removeImage}>Excluir</p>
            </div>
          </div>
        ) : (
          <>
            <input {...getInputProps()} />
            <p >Arraste seu arquivo aqui ou <span className="underline">selecione</span></p>
            <p>Arquivos permitidos PDF,PNG,JPG,JPEG</p>
          </>
        )}
      </div>
    </DragOnDrop>
    <span style={{width:'33%', height:'51px'}} onClick={onHandleSend}>Enviar</span >
    </>
  );
};

export default ImageUpload;